module.exports = __webpack_public_path__ + "images/kihnu/routes/pointers/KEL-LEP-KEL.png";